import { createSlice } from '@reduxjs/toolkit'
import { dataControlEntityInitialState as initialState } from '../initialState/dataControlEntityState'
import { apiCallBegan } from '../api'

// The Data Controls Entity is READ-ONLY in the portal: its service entities and
// scan rules are seeded by DB scripts and surfaced via GET-only endpoints. There
// are no write thunks here.
const slice = createSlice({
  name: 'dataControlEntity',
  initialState: initialState,
  reducers: {
    serviceEntitiesRequested: (s) => { s.serviceEntitiesLoading = true },
    serviceEntitiesReceived: (s, a) => {
      s.serviceEntitiesLoading = false
      s.serviceEntities = a.payload.response?.data ?? a.payload.response ?? []
    },
    serviceEntitiesFailed: (s, a) => { s.serviceEntitiesLoading = false; s.error = true; s.message = a.payload?.message ?? 'Failed to load service entities' },

    scanRulesRequested: (s) => { s.scanRulesLoading = true },
    scanRulesReceived: (s, a) => {
      s.scanRulesLoading = false
      s.scanRules = a.payload.response?.data ?? a.payload.response ?? []
    },
    scanRulesFailed: (s, a) => { s.scanRulesLoading = false; s.error = true; s.message = a.payload?.message ?? 'Failed to load scan rules' },

    extensionCatalogueRequested: (s) => { s.extensionCatalogueLoading = true },
    extensionCatalogueReceived: (s, a) => {
      s.extensionCatalogueLoading = false
      s.extensionCatalogue = a.payload.response?.data ?? a.payload.response ?? []
    },
    extensionCatalogueFailed: (s, a) => {
      s.extensionCatalogueLoading = false; s.error = true
      s.message = a.payload?.message ?? 'Failed to load the extension catalogue'
    },

    clearDataControlEntityStatus: (s) => { s.statusCode = null; s.message = ''; s.error = false },
  },
})

export const {
  serviceEntitiesRequested, serviceEntitiesReceived, serviceEntitiesFailed,
  scanRulesRequested, scanRulesReceived, scanRulesFailed,
  extensionCatalogueRequested, extensionCatalogueReceived, extensionCatalogueFailed,
  clearDataControlEntityStatus,
} = slice.actions

export default slice.reducer

// ===========================================================================
// Thunks — read-only data-controls-entity GETs.
// ===========================================================================

export const getServiceEntities = () => apiCallBegan({
  urlPath: '/portal/data-controls-entity/service-entities', method: 'GET',
  onStart: serviceEntitiesRequested.type, onSuccess: serviceEntitiesReceived.type, onError: serviceEntitiesFailed.type,
})

export const getScanRules = () => apiCallBegan({
  urlPath: '/portal/data-controls-entity/scan-rules', method: 'GET',
  onStart: scanRulesRequested.type, onSuccess: scanRulesReceived.type, onError: scanRulesFailed.type,
})

// The seeded extension catalogue + per-browser native ids. A new {resource} value on
// the existing route, so no new endpoint. GET only -- there is deliberately no write
// path anywhere for this data: it is maintained by population scripts.
export const getExtensionCatalogue = () => apiCallBegan({
  urlPath: '/portal/data-controls-entity/extensions', method: 'GET',
  onStart: extensionCatalogueRequested.type, onSuccess: extensionCatalogueReceived.type, onError: extensionCatalogueFailed.type,
})
